import React, { Component } from "react";
import { favouritesService } from "~/js/_services";
import OpSlider from "~/js/components/op-slider";
import { w } from "./../utils";
import LazyBackgroundImage from "./LazyBackgroundImage";
import { groupDealerships, formatGroupLabel, excludeDealerships } from "~/js/utils";

let regions =  [];
let ribbonData = {};
class Tile extends Component {
    state = {
        isFavourite: false,
    };

    constructor(props) {
        super(props);
        regions = this.props.regions
        ribbonData = this.props.ribbonData;

        this.imageSliderRef = React.createRef();
        this.imageFrameRef = React.createRef();
        this.imageListRef = React.createRef();

        const images = this.props["Images"];
        images.Image = Array.isArray(images.Image)
            ? images.Image
            : [images.Image];
        this.imageRefs = images.Image.map(() => {
            return React.createRef();
        });
    }

    componentDidMount() {
        const id = this.props["@LISTING_SEQ"];
        const { hasSlider } = this.props;
        // console.log('Tile componentDidMount:', id);
        this.subscription = favouritesService.current.subscribe(this.check);

        let config = {
            slider: this.imageSliderRef.current,
            frame: this.imageFrameRef.current,
            list: this.imageListRef.current,
            slides: this.imageRefs.map((r) => r.current),
            speed: 0.07,
        };

        this.slider = new OpSlider(config);

        window.thatSlider = this.slider;
    }

    componentDidUpdate() {
        const id = this.props["@LISTING_SEQ"];
        this.check();
        // console.log(`Tile componentDidUpdate ${id}`, this.state.isFavourite)
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    check = () => {
        const id = this.props["@LISTING_SEQ"];
        const { isFavourite: isF } = this.state;
        const isFavourite = favouritesService.isFavourite(id);


        // console.log(`Tile check ${id}:`, isFavourite);

        if (isF !== isFavourite) {
            this.setState({ isFavourite });
        }
    };

    toggleFavourite = (e) => {
        e.preventDefault();
        const id = this.props["@LISTING_SEQ"];
        const { isFavourite } = this.state;
        const { addFavourite, removeFavourite } = favouritesService;

        if (isFavourite) {
            removeFavourite(id);
        } else {
            addFavourite(id);
        }
    };

    getDealership(yard){
        let foundYard = "";
        regions.forEach(region => {
            if(region.dealerships){
                region.dealerships.forEach(dealer => {
                    if(dealer.data.autoplay.yards){
                        dealer.data.autoplay.yards.forEach(yards =>{
                           if(yards.id === yard){
                               foundYard = dealer;

                           }
                        })
                    }
                })
            }
        })

        return foundYard;
    }
    showBlackFridayBanner(save){
        if(!save){
            return false;
        }
        const intSavings = parseInt(save.replace(/\$|,/g, ''), 10);
        const savingsOptions =  window.black_friday_savings ?? false;
        const bfSalesOn = (savingsOptions['sale-on'] ?? false) === 'yes';
        if(!bfSalesOn){
            return false;
        }
        const bfSaleLowerLimit = savingsOptions['saving-range-price-min'];
        const bfSaleUpperLimit = savingsOptions['saving-range-price-max'];

        if(!bfSaleLowerLimit && !bfSaleUpperLimit){
            return true;
        }
        if(!bfSaleLowerLimit && intSavings <= bfSaleUpperLimit){
            return true;
        }
        if(!bfSaleUpperLimit && intSavings >= bfSaleLowerLimit){
            return true;
        }
        return intSavings <= bfSaleUpperLimit && intSavings >= bfSaleLowerLimit;


    }

    hasAlternateLabel(yardID) {
        const alternateYardNames = window.alternate_yard_names['repeating-yard-name'];

        if (Array.isArray(alternateYardNames)) {
            const match = alternateYardNames.find(entry => parseInt(entry.yardId) === parseInt(yardID));
            if (match) {
                return match.name;
            }
        }

        return false;
    }


    render() {
        const { isFavourite } = this.state;
        // console.log('Tile render isFavourite:', isFavourite, this.props['@LISTING_SEQ']);
        const listingPrice = parseInt(this.props["@LISTING_PRICE"]);
        const specialPrice = parseInt(this.props["@LISTING_PRICE_SPECIAL"]);

        // const name = this.props['@LISTING_TITLE'];
        const name = `${this.props["@LISTING_YEAR"]} ${this.props["@LISTING_MAKE"]} ${this.props["@LISTING_MODEL"]}`;
        const miles = this.props["@LISTING_ODOMETER_DISPLAY"];
        const created = this.props["@Created"];

        const id = this.props["@LISTING_SEQ"];
        const listingdemo = this.props["@LISTING_DEMO"];
        const listingnew = this.props["@LISTING_NEW"];
        const make = this.props["@LISTING_MAKE"].replace(" ", "-").toLowerCase();
        const model = this.props["@LISTING_MODEL"].replace(" ", "-").replace("#","").toLowerCase();
        const spec = this.props["@LISTING_VARIANT"];
        const yard = this.props['@BODY_YARD_SEQ'];
        const dealerData = this.getDealership(yard);
        const dealer = dealerData?.post_name ? dealerData.post_name : "";
        const dealerLabel = this.hasAlternateLabel(yard) || dealerData?.post_title || "";
        const info = `${this.props["@LISTING_CC"]}cc, ${this.props["@LISTING_FUEL_TYPE"]}, ${this.props["@LISTING_TRANSMISSION"]}`;
        const images = this.props["Images"];
        images.Image = Array.isArray(images.Image)
            ? images.Image
            : [images.Image];

        const { hasSlider, isReserved } = this.props;
        let url = "used-vehicle";
        if(listingdemo == 'True'){
            url = "demonstrator-vehicle";
        }
        if(listingnew == 'True'){
            url = "new-vehicle";
        }

        // const isSpecial = this.props['@LISTING_SPECIAL'] === 'True';
        let save = null;
        let price = null;

        if (!isNaN(specialPrice) && specialPrice > 0) {
            price = specialPrice;

            if (specialPrice > 0) {
                save = listingPrice - specialPrice;
                save = `$${new Intl.NumberFormat("en-US").format(save)}`;
            }
        } else {
            price = listingPrice;
        }

        if (price === 0) {
            price = this.props["@LISTING_PRICE_DISPLAY"]
                .trim()
                .replace(/\s/g, "");
        } else {
            price = `$${new Intl.NumberFormat("en-US").format(price)}`;
        }
        let src = `https://data.autoplay.co.nz/image.ashx?id=${this.props["@LISTING_IMAGE_SEQ"]}&h=242&w=348&crop=1`;
        if(this.props['s3Image'] == true){
            src = images['Image'][0]['@url'];
        }
        // if (images.Image && images.Image[0]) {
        //     src = images.Image[0]['@url'] ? images.Image[0]['@url'] + "&h=242&w=348&crop=1" : null;
        // }
        const has1hrTriggerText = "driveaway in minutes";
        const has1hrDelivery =
            this.props["@LISTING_COMMENTS"]
                .toLowerCase()
                .includes(has1hrTriggerText) ||
            this.props["@LISTING_FEATURES"]
                .toLowerCase()
                .includes(has1hrTriggerText)  ||
            this.props?.Listing_Label_Type_List?.LISTING_LABEL_TYPE_NAME == "60 Minute Delivery";

        let breakPills = false;
        let lowEmissions = false;
        let neutralEmissions = false;
        if(this.props["@LISTING_VIN"] !== "") {
            if (!(this.props["@LISTING_CO2"] === '0' && this.props["@LISTING_FUEL_TYPE"] !== 'Electric')) {
              if (this.props["@LISTING_CO2"] < 146) {
                    lowEmissions = true;
                } else if (this.props["@LISTING_CO2"] < 192) {
                    neutralEmissions = true;
                }
            }
        }

        let iownEligable = false;
        if(this.props["@LISTING_NEW"].toLowerCase() == "true" && (this.props["@LISTING_MAKE"] == "Opel" || this.props["@LISTING_MAKE"] == "Citroen" || this.props["@LISTING_MAKE"] == "Peugeot")){
            iownEligable = true;
        }
        const savingsOptions =  window.black_friday_savings ?? false
        const saleHeading = (savingsOptions['heading'] ?? "").trim() !== ""
            ? savingsOptions['heading']
            : "<p><b>BLACK FRIDAY </b>MEGA DEAL</p>";

        const showBfSaleBanner = this.showBlackFridayBanner(save)
        if (save && has1hrDelivery) {
            breakPills = true;
        }
        const bannerColor = savingsOptions['color-picker-background'] ?? "black";


        let loanRepayment = 0;
        if(price.charAt(0) == '$') {
            let totalPrice = price.replace('$', '');
            totalPrice = parseInt(totalPrice.replaceAll(',', ''));
            let fLoanAmount = Math.round(totalPrice * .65, 4) + 518.39; // Total price of vehicle excluding 35% deposit

            let fAPR = 11.95; // 11.95% finance
            let iTerm = 52*5; // 5 year term in weeks
            let monthlyInterestRate = fAPR / 100 / 52;
            let LoanOutput = fLoanAmount *
                (
                    (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, iTerm))
                    /
                    (Math.pow(1 + monthlyInterestRate, iTerm) - 1)
                );
            loanRepayment = Math.ceil(LoanOutput);
        }


        return (
            <div className={`tile ${isFavourite ? "is-favourite" : ""}`}>                <a
                    href={`/our-vehicles/make-${make}/model-${model}/dealer-${dealer}/${url}?c=${id}`}
                    className="tile__image"
                    draggable="ffalse"
                >
                    <div
                        className={`tile__slider-container ${
                            hasSlider && w.w <= 768
                                ? ""
                                : "tile__slider-container--disabled"
                        }`}
                        ref={this.imageSliderRef}
                    >
                        <div
                            className="tile__slider-frame"
                            ref={this.imageFrameRef}
                        >
                            <div
                                className="tile__slider-list"
                                ref={this.imageListRef}
                            >
                                {images.Image.map((image, index) => {
                                    return (
                                        <LazyBackgroundImage
                                            key={index}
                                            ref={this.imageRefs[index]}
                                            className={`tile__image-bg tile__image-bg--is-slider`}
                                            src={`${image["@url"]}&h=300`}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div  className={`tile__image-parent`}>

                        <LazyBackgroundImage
                            className={`tile__image-bg ${
                                hasSlider && w.w <= 768
                                    ? "tile__image-bg"
                                    : ""
                            }`}
                            src={src}
                        >
                        {showBfSaleBanner ? (<div className="tile__savings-banner" style={{backgroundColor:bannerColor}} dangerouslySetInnerHTML={{ __html: saleHeading }}></div>) : false }

                        </LazyBackgroundImage>
                    </div>

                    {isReserved ? (
                        <div className={"tile__reserved-overlay"}>
                            <span className={"tile__reserved_text"}>
                                VEHICLE UNDER OFFER
                            </span>
                        </div>
                    ) : null}
                </a>
                <span className={`tile__content`}>
                    <div className="tile__text-block">
                        <a
                            href={`/our-vehicles/make-${make}/model-${model}/${url}?c=${id}`}
                            className="tile__name"
                        >
                            {name}
                        </a>
                        <span className="tile__spec">{spec}</span>
                     </div>
                    <div className="tile__meta-block">
                         <span className="tile__info tile__mileage">
                          {miles ? miles : ('')}
                        </span>

                        <span className="tile__info tile__dealer-name">
                          <span className="tile__dealer-name__icon" />
                          <span className="tile__dealer-name__text">
                            {dealerLabel ? dealerLabel : (<div><p>&nbsp;</p></div>)}
                          </span>
                        </span>
                    </div>
                </span>
                <span className={`tile__bottom`}>
                     <span
                         className={`tile__price ${
                             breakPills ? "tile__price--break" : ""
                         }`}
                     >
                            <div className={`tile__price-container`}>
                                <span>{price}</span>
                                <span className={'tile__interest-pw'}>${loanRepayment} per week*</span>
                            </div>
                        </span>
                       <div className="tile__ribbons">
                             {save && (
                                 <div
                                     className="tile__ribbon tile__ribbon--save"
                                     style={{
                                         backgroundColor: ribbonData?.savings,
                                         color: '#333',
                                         '--ribbon-highlight': ribbonData?.savingsHighlight || '#FFD600',
                                     }}
                                 >
                                     SAVE {save}
                                 </div>
                             )}

                           {has1hrDelivery && (
                               <div
                                   className="tile__ribbon tile__ribbon--delivery"
                                   style={{
                                       backgroundColor: ribbonData?.express,
                                       color: '#222',
                                       '--ribbon-highlight': ribbonData?.expressHighlight || '#222222',
                                   }}
                               >
                                   {ribbonData?.expressText || 'DRIVE AWAY IN 60 MINUTES'}
                               </div>
                           )}
                            </div>
                </span>
            </div>
        );
    }
}

export {Tile};

